import axios from "http/customAxios";

type DeviceInfoType = {
  osName: string;
  browserVersion: string;
  deviceType: string;
  browserName: string;
  browserEngineName: string;
};

type LocationType = {
  countryCode: string;
  cityName: string;
};

type BodyPropertyARIType = {
  propertyTicker?: string;
  start: string;
  end: string;
  seniors: number;
  adults: number;
  teenagers: number;
  children: number;
  babies: number | null;
  propertyTickers: boolean | null;
  promoCodes: string[];
  inventoryTickersLikeFilter: boolean | null;
  inventoryTickersEqualFilter: boolean | null;
  guestAges: number[] | null;
  channel: boolean | null;
  ignoredConfiguration: false;
  deviceInfo: DeviceInfoType;
  totalAmount: number | null;
  reservationAmount: number | null;
  locationInfo: LocationType;
};

type DataPropertyARIType = {
  [key: string]: {
    ticker: string;
    type: string;
    inventories: {
      ticker: string;
      name: string;
      discountTickers: string[];
    };
    arivalues: {
      [key: string]: {
        name: string;
        ticker: string;
        totalRate: number;
        averageRate: number;
        restricted: boolean;
        unavailable: boolean;
        originalRate: number;
        rackRate: number;
        cityTax: number;
      };
    };
  };
};

type CustomDataPropertyARIType = {
  [key: string]: {
    ticker: string;
    name: string;
    price: number;
    averageRate: number;
    originalRate: number;
    rackRate: number;
    cityTax: number;
  };
};

type ItemResultJsonType = {
  type: string;
  expectedValue?: number;
  givenValue?: number;
  value?: string;
};

type ResultJsonType = {
  [key: string]: {
    gha: {
      discrepancies: ItemResultJsonType[];
    };
    tripadvisor: {
      discrepancies: ItemResultJsonType[];
    };
    trivago: {
      discrepancies: ItemResultJsonType[];
    };
  };
};

type InitialResultJsonType = {
  propertyTicker: string;
  results: ResultJsonType;
};

const getDataPropertyARI = (propertyARIRoute: string, body: BodyPropertyARIType) => {
  return axios.post(propertyARIRoute, body);
};

const transformPropertyARI = (dataPropertyARI: DataPropertyARIType, propertyTicker: string) => {
  const inventories = dataPropertyARI[propertyTicker].inventories;
  const ariValues = dataPropertyARI[propertyTicker].arivalues;
  const customDataPropertyARI: CustomDataPropertyARIType = {};
  const initialResultJson: InitialResultJsonType = {
    propertyTicker,
    results: {
      not_records: {
        gha: {
          discrepancies: [],
        },
        tripadvisor: {
          discrepancies: [],
        },
        trivago: {
          discrepancies: [],
        },
      },
    },
  };

  const isInventoryAvailable = (ariValue: any) =>
    ariValue.totalRate && !ariValue.unavailable && !ariValue.restricted;

  for (const key in inventories) {
    if (isInventoryAvailable  (ariValues[key])) {
      customDataPropertyARI[key] = {
        ticker: inventories.ticker,
        name: inventories.name,
        price: ariValues[key].totalRate,
        averageRate: ariValues[key].averageRate,
        originalRate: ariValues[key].originalRate,
        rackRate: ariValues[key].rackRate,
        cityTax: ariValues[key].cityTax,
      };

      initialResultJson.results[key] = {
        gha: {
          discrepancies: [],
        },
        tripadvisor: {
          discrepancies: [],
        },
        trivago: {
          discrepancies: [],
        },
      };
    }
  }
  return { customDataPropertyARI, initialResultJson };
};

export const myPropertyARI = async (
  propertyTicker: string,
  propertyARIRoute: string,
  data: BodyPropertyARIType
) => {
  const { data: dataPropertyARI } = await getDataPropertyARI(propertyARIRoute, data);
  return transformPropertyARI(dataPropertyARI, propertyTicker);
};
